/**
 * Calorie & macro helpers.
 *
 * SESSION 3 removed the client-side BMR/TDEE/calorie-target math.
 * Calorie and macro goals now come from the server via
 *   GET /api/users/me/calorie-goal
 * so web and mobile always agree on the same daily number.
 *
 * Only the goal-projection helper (weeks to target weight, a UI-only
 * estimate) is kept.
 */

export function projectWeeksToGoal(profile) {
  if (!profile?.weight_kg || !profile?.goal_weight_kg) return null;
  const diff = Math.abs(profile.weight_kg - profile.goal_weight_kg);
  const pace = profile.goal === "Lose Fat" ? 0.5 : 0.3; // kg/week
  return Math.max(2, Math.round(diff / pace));
}
